<template>
  <span class="expand-wrap" @expansion="handleExpansion">
    <span v-if="expanded" class="expand-wrap--icon expand-wrap--icon__minus">&minus;</span>
    <span v-else class="expand-wrap--icon expand-wrap--icon__plus">&#43;</span>
  </span>
</template>

<script>
export default {
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    handleExpansion(event) {
      this.expanded = event.detail.expanded;
    },
  },
};
</script>

<style lang="scss" scoped>
  .expand-wrap {
    display: inline-flex;
    align-items: flex-end;
    justify-content: center;
    height: 22px;
    width: 22px;
    border-radius: 2px;
    background-color: #00BEC9;
    color: #fff;
    cursor: pointer;
    user-select: none;

    .expand-wrap--icon {
      display: inline-block;
      font-weight: bolder;
      font-size: 24px;
      line-height: 22px;
    }
  }
</style>



// WEBPACK FOOTER //
// ExpandButton.vue?39e923e4